export default function getOrPut<K, V>(map: Map<K, V>, key: K, getDefault: () => V): V {
	if (map.has(key)) {
		return map.get(key) as V
	}
	const defaultValue = getDefault()
	map.set(key, defaultValue)
	return defaultValue
}
